import { render, staticRenderFns } from "./pay-2.vue?vue&type=template&id=5008c854&scoped=true&"
import script from "./pay-2.vue?vue&type=script&lang=js&"
export * from "./pay-2.vue?vue&type=script&lang=js&"
import style0 from "./pay-2.vue?vue&type=style&index=0&id=5008c854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5008c854",
  null
  
)

export default component.exports